import React from 'react';
import PropTypes from 'prop-types';

import Banner, { BANNER_TYPES } from 'components/common/banner-component';

import { ModalButton } from 'models/utils/common/modal-button-model';
import Modal from 'components/common/modal-component';

const PROJECT_EDIT_PAGE_ID_BLOCK = 'project-edit-id';

const ProjectEditCancelModal = ({
  toggleCancelModal,
  onCancelAndLeavePage,
}) => {
  return (
    <Modal
      id={`${PROJECT_EDIT_PAGE_ID_BLOCK}-cancel-modal`}
      title={'project-edit.cancel-modal.title'}
      onClose={toggleCancelModal}
      primaryModalButton={
        new ModalButton({
          text: 'common.yes',
          onClick: onCancelAndLeavePage,
        })
      }
      secondaryModalButton={
        new ModalButton({
          text: 'common.no',
          onClick: toggleCancelModal,
        })
      }
    >
      <Banner
        id={`${PROJECT_EDIT_PAGE_ID_BLOCK}-cancel-modal-warning-banner`}
        type={BANNER_TYPES.WARNING}
        bannerCopy={'project-edit.cancel-modal.warning'}
        isInternationalized={true}
        isInteractive={false}
      />
    </Modal>
  );
};

ProjectEditCancelModal.propTypes = {
  /** Method on the project edit component that closes project edit cancel modal */
  toggleCancelModal: PropTypes.func.isRequired,
  /** Method on the project edit component that let user leave project edit page */
  onCancelAndLeavePage: PropTypes.func.isRequired,
};

export default ProjectEditCancelModal;
